<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class='row h-row-around-inputBox'>
      <div class='col-sm-12'>

        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{this.$t('MCS.taskName')}}:</div>
          <input class="e-input" type="text" v-model="modifyTaskName" disabled="disabled" maxlength="20"/>
        </div>


        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{this.$t('MCS.importType')}}:</div>
          <ejs-dropdownlist ref='importModifyType' :enabled='false' :change="changeForModifyImportType" id='importType' :dataSource='dataSourceOfImportModifyType' :fields='fieldsOfImportModifyType' v-model='importModifyType'></ejs-dropdownlist>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{this.$t('MCS.isCover')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.cover")' name="isModifyCover" value='1' :checked='true' :change='coverModifyChange' ></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.skip")' name="isModifyCover"  value='0' :change='coverModifyChange' ></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox' v-show="isShowModifyBlackList">
          <div class='h-inputLit'>{{this.$t('MCS.blackListDealType')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.append")' name='modifyBlackList' value='0' :checked='true' :change='blackListModifyChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='modifyBlackList' value='1' :change='blackListModifyChange'></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox' v-show="isShowModifyRelations">
          <div class='h-inputLit'>{{this.$t('MCS.groupMemberDealType')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.append")' name='modifyRelations' value='0' :checked='true' :change='relationsModifyChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='modifyRelations' value='1' :change='relationsModifyChange'></ejs-radiobutton>
            </div>
          </div>
        </div>
        <div class='h-col-inputBox' v-show="isShowModifyAreas">
          <div class='h-inputLit'>{{this.$t('MCS.groupAreaDealType')}}:</div>
          <div class='row'>
            <div class='col-sm-3 nopadding'>
              <ejs-radiobutton :label='$t("MCS.append")' name='modifyAreas' value='0' :checked='true' :change='areasModifyChange'></ejs-radiobutton>
            </div>
            <div class='col-sm-3 nopadding' style='padding-left: 15px'>
              <ejs-radiobutton :label='$t("MCS.cover")' name='modifyAreas' value='1' :change='areasModifyChange'></ejs-radiobutton>
            </div>
          </div>
        </div>


        <div class='h-col-inputBox'>
          <div class="h-inputLit">
            <ejs-button :isPrimary="true" @click.native="uploadModifyFile">{{this.$t('System.selectFile')}}</ejs-button>
          </div>
          <div class="fl" v-show="modifyFileShow">
            <input
              class="e-input"
              type="text"
              v-model="modifyFileName"
              style="width:300px; float:left;"
              disabled='disabled'
            />
            <ejs-button ref="delTaskButton"
                        iconCss="icon hero-icon h-spectrum-icon hero-icon-remove"
                        cssClass="e-small e-round"
                        :isPrimary="true"
                        @click.native="deleteModifyFile">
            </ejs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-system-hide-upload" id="modifyUpload">
      <ejs-uploader
        ref="importActiveFile"
        name="importActiveFile"
        id="importActiveFile"
        :multiple="false"
        :autoUpload="false"
        :selected="onModifySelect"
      ></ejs-uploader>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BatchManagementModify",
    data() {
      return {
        modifyTaskName: '',
        importModifyType: 3,
        dataSourceOfImportModifyType: [
          {
            value: 1,
            text: this.$t('MCS.organizationImport')
          },
          {
            value: 2,
            text: this.$t('MCS.cellImport')
          },
          {
            value: 3,
            text: this.$t('MCS.userGroupMemberImport')
          },
          {
            value: 4,
            text: this.$t('MCS.blackImport')
          },
          {
            value: 5,
            text: this.$t('MCS.userAuthAreaImport')
          },
          {
            value: 6,
            text: this.$t('MCS.groupCallImport')
          }
        ],
        fieldsOfImportModifyType: {
          value: 'value',
          text: 'text'
        },
        isShowModifyBlackList: false,
        isShowModifyRelations: true,
        isShowModifyAreas: false,
        modifyFileShow: false,
        modifyFileName: '',
        isModifyCover: 1,


        blacklistModifyDealType: 0,
        relationsModifyDealType: 0,
        areasMofidyDealType: 0,
        importModifyFile: null,
      }
    },
    methods: {
      changeForModifyImportType(msg){
        let aa = this.$refs.importType;
        console.log(aa);
        const selectImportType = msg.value;
        switch (selectImportType) {
          case 4:
            this.isShowModifyBlackList = true;
            this.isShowModifyRelations = false;
            this.isShowModifyAreas = false;
            break;
          case 3:
            this.isShowModifyRelations = true;
            this.isShowModifyBlackList = false;
            this.isShowModifyAreas = false;
            break;
          case 6:
            this.isShowModifyAreas = true;
            this.isShowModifyRelations = false;
            this.isShowModifyBlackList = false;
            break;
          default:
            this.isShowModifyAreas = false;
            this.isShowModifyRelations = false;
            this.isShowModifyBlackList = false;
            break;

        }
      },
      coverModifyChange(args) {
        this.isModifyCover = args.value;
      },
      blackListModifyChange(args) {
        this.blacklistModifyDealType = args.value;
      },
      relationsModifyChange(args) {
        this.relationsModifyDealType = args.value;
      },
      areasModifyChange(args) {
        this.areasMofidyDealType = args.value;
      },
      uploadModifyFile() {
        document
          .getElementById('modifyUpload')
          .querySelector('button')
          .click();
        return false;
      },
      deleteModifyFile(){
        this.modifyFileShow = false;
        this.importModifyFile = null;
        this.$refs.importActiveFile.clearAll();
      },
      onModifySelect(args) {
        const file = args.filesData[0];
        this.modifyFileName = '';
        this.modifyFileName = file.name;
        console.log(`fileName=${this.modifyFileName}`);
        this.importModifyFile = null;
        this.importModifyFile = file.rawFile;
        console.log(`importFile=${this.importModifyFile}`);
        this.modifyFileShow = true;
      }
    }
  }
</script>

<style>
</style>
